import { FC, PropsWithChildren } from 'react';
import styled from '@emotion/styled';
import { Typography } from '../typography/typography';

interface BadgeInterface extends PropsWithChildren {
  size: 'small' | 'large';
  label: string;
  color?: string;
  textColor?: string;
  type?: 'filled' | 'outlined';
}

interface StyledBadgeProps {
  size: 'small' | 'large';
  color?: string;
  type?: 'filled' | 'outlined';
}

const StyledBadge = styled.div<StyledBadgeProps>`
  display: inline-flex;
  border: 1px solid
    ${(props) => (props.type === 'outlined' ? props.color : 'inherit')};
  background-color: ${(props) =>
    props.type === 'outlined' ? 'inherit' : props.color};

  border-radius: ${(props) => (props.size === 'small' ? '68px' : '8px')};
  padding: ${(props) =>
    props.size === 'large'
      ? 'var(--rk-spacing-sm) var(--rk-spacing-lg)'
      : 'var(--rk-spacing-xs) var(--rk-spacing-md)'};
`;

const DynamicTypography = styled(Typography)<{
  type?: string;
  color: string;
  textColor?: string;
}>`
  color: ${(props) =>
    props.textColor
      ? props.textColor
      : props.type === 'outlined'
        ? props.color
        : 'var(--md-ref-primary-100)'};
`;

export const Badge: FC<BadgeInterface> = ({
  size,
  label,
  color = 'var(--md-ref-secondary-40)',
  textColor,
  type = 'outlined',
}) => {
  const typographyVariant =
    size === 'small' ? 'textLabelSmall' : 'textLabelMediumSurface';

  return (
    <StyledBadge type={type} size={size} color={color}>
      <DynamicTypography
        type={type}
        variant={typographyVariant}
        color={color}
        textColor={textColor}
      >
        {label}
      </DynamicTypography>
    </StyledBadge>
  );
};
